import EditCourseMenu, { EditCourseMenuProps } from './EditCourseMenu';
import withInteractor from './EditCourseMenu.interactor';
import withPresenter from './EditCourseMenu.presenter';

export type { EditCourseMenuProps };
export default withInteractor(withPresenter(EditCourseMenu));
